import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";

const addData = (data, orgId, deptId, appId, env) => {
  let name = "Default " + faker.lorem.word();
  let description = faker.lorem.sentence(3);
  let _orgId = uuidv4();
  let _deptId = uuidv4();
  let _appId = uuidv4();
  if (data) {
    name = data.Name;
    _orgId = orgId;
    _deptId = deptId;
    _appId = appId;
    description = data.Description;
  }
  return {
    Name: env ? env.EnvironmentName : name,
    OrganizationId: _orgId,
    DepartmentId: _deptId,
    ApplicationId: _appId,
    Description: env ? env.description : description,
    ID: env ? env.EnvironmentId : uuidv4(),
    CreatedOn: faker.date.past(),
    ModifiedOn: faker.date.past(),
    ParentOrganizationId: "",
    ModifiedBy: null,
    CreatedBy: 2,
    CustomerId: uuidv4(),
  };
};

export const createEnvironment = (data, orgId, deptId, appId, env) => {
  const envData = addData(data, orgId, deptId, appId, env);
  return envData;
};
